import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import classNames from "clsx";
import { FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import SidebarLink from "./SidebarLink";

const SidebarNavAccordion = ({ link, isCollapsed }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const hasActiveChild = link.sublinks?.some(
    (sl) => pathname === sl.path || pathname.startsWith(sl.path + "/"),
  );

  const [open, setOpen] = useState(hasActiveChild ?? false);

  useEffect(() => {
    if (hasActiveChild) setOpen(true);
  }, [hasActiveChild]);

  return (
    <div className="w-full">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-3 pl-[16px] pr-4 text-sm transition-colors text-left"
      >
        <span className="flex items-center justify-center w-10 h-10 rounded-full shrink-0 text-gray-500">
          {link.icon}
        </span>

        <span
          className="text-sm text-gray-700 whitespace-nowrap overflow-hidden"
          style={{
            maxWidth: isCollapsed ? 0 : 180,
            opacity: isCollapsed ? 0 : 1,
            visibility: isCollapsed ? "hidden" : "visible",
            transition: isCollapsed
              ? "max-width 250ms ease-in-out, opacity 100ms ease-in-out"
              : "max-width 250ms ease-in-out, opacity 200ms ease-in-out 80ms",
          }}
        >
          {t(`main.sidebar.${link.key}`, link.label)}
        </span>

        <FaChevronRight
          className={classNames(
            "ml-auto text-xs transition-transform flex-shrink-0",
            open && "rotate-90",
          )}
          style={{ opacity: isCollapsed ? 0 : 1 }}
        />
      </button>

      {!isCollapsed && open && (
        <div className="pl-4 flex flex-col">
          {link.sublinks?.map((sublink) => (
            <SidebarLink key={sublink.key} link={sublink} isCollapsed={isCollapsed} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarNavAccordion;
